import React from 'react'

import { DataItem } from 'scrivito'

import { StringText } from '@/Atomic/Atoms/StringText'

interface HeaderTextProps {
  title: string
  subtitle?: string
  link?: string
  linkDataItem?: DataItem
}

export const HeaderText: React.FC<HeaderTextProps> = ({
  title,
  subtitle,
  link,
  linkDataItem,
}) => {
  return (
    <div className="text">
      <StringText value={title} className="title" />
      <div className="meta">
        <StringText value={subtitle} className="subtitle" />
        <StringText
          variant={linkDataItem ? 'link' : undefined}
          value={link}
          className={linkDataItem ? 'link' : undefined}
          dataItem={linkDataItem}
        />
      </div>
    </div>
  )
}
